import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../../redux-store";

export const selectCargoReport = (state: RootState) => state.data.cargosReport;

export const selectCargosReportRows = createSelector(
  selectCargoReport,
  (cargosReport) => cargosReport.cargosReportPageData
);

export const selectCargoReportRows = (cargoId: string) =>
  createSelector(
    selectCargoReport,
    (cargosReport) => cargosReport.cargoModalData[cargoId] ?? []
  );

export const selectFilteredTeams = createSelector(
  selectCargoReport,
  (cargosReport) => cargosReport.filterTeamIds
);
